import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { ApiVisa } from '../shared/api-visa.model';
import { BasicApiResponseModel, PagingResponseModel } from '../shared/api-response.model';
import { Pagination } from '../shared/pagination.model';
import { FpxRequestMessageModel } from '../../../../../models/aggregates/payment-gateway/fpx-request-message.model';
import { FpxBankListModel } from '../../../../../models/aggregates/payment-gateway/fpx-bank-list.model';
import { EMandateContainerModel } from '../../../../../models/aggregates/payment-gateway/e-mandate-container.model';
import { EntityEventContainerModel } from '../../../../../models';

@Injectable({
  providedIn: 'root'
})
export class FpxInternalService extends BaseApiTemplateService<FpxRequestMessageModel> {

  readonly url = Core2Config.LOCAL_HOST + Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + 'paygw/my/fpx';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = this.url;
    this.endpoint_path = Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + 'paygw/my/fpx';
    this.httpClient = http;
  }

  public getPmtRefNo(
    visa: ApiVisa
  ): Promise<BasicApiResponseModel<string>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const Url = this.apiUrl + '/pmt-ref-no';
    return this.httpClient.get<BasicApiResponseModel<string>>
      (Url, this.getHttpHeader(visa))
      .toPromise();
  }

  public getBankList(
    visa: ApiVisa,
    fpx_msgToken: string,
    settlementMethodGuid: string
  ): Promise<BasicApiResponseModel<FpxBankListModel[]>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const Url = this.apiUrl + '/banks?fpx_msgToken=' + fpx_msgToken + '&settlementMethodGuid=' + settlementMethodGuid;
    return this.httpClient.get<BasicApiResponseModel<Array<any>>>
      (Url, this.getHttpHeader(visa))
      .toPromise();
  }

  public generateAdReqMsg(
    visa: ApiVisa,
    eMandateContainerModel: EMandateContainerModel
  ): Promise<BasicApiResponseModel<FpxRequestMessageModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const Url = this.apiUrl + '/ad-request-message';
    return this.httpClient.post<BasicApiResponseModel<FpxRequestMessageModel>>
      (Url,
        eMandateContainerModel,
        this.getHttpHeader(visa))
      .toPromise();
  }

  public getEMandateByGuid(
    visa: ApiVisa,
    eMandateGuid: string
  ): Promise<BasicApiResponseModel<EMandateContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const Url = this.apiUrl + '/e-mandate/' + eMandateGuid;
    return this.httpClient.get<BasicApiResponseModel<EMandateContainerModel>>
      (Url, this.getHttpHeader(visa))
      .toPromise();
  }

  public getEMandateEventByGuid(
    visa: ApiVisa,
    eventGuid: string
  ): Promise<BasicApiResponseModel<EntityEventContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const Url = this.apiUrl + '/e-mandate-event/' + eventGuid;
    return this.httpClient.get<BasicApiResponseModel<EntityEventContainerModel>>
      (Url, this.getHttpHeader(visa))
      .toPromise();
  }

  public getEMandateByCriteria(
    pagination: Pagination,
    visa: ApiVisa
  ): Promise<PagingResponseModel<EMandateContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const Url = this.apiUrl + '/e-mandate/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<EMandateContainerModel>>
      (Url, this.getHttpHeader(visa))
      .toPromise();
  }
}
